import { z } from "zod";
import { isoDateSchema, objectIdSchema } from "./common";
export const dayKeySchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Expected YYYY-MM-DD");
export const monthKeySchema = z.string().regex(/^\d{4}-\d{2}$/, "Expected YYYY-MM");
export const usageCounterSchema = z.object({
    _id: objectIdSchema,
    userId: objectIdSchema,
    dayKey: dayKeySchema,
    monthKey: monthKeySchema,
    sentCount: z.number().int().min(0),
    receivedCount: z.number().int().min(0),
    // Required for the 400-day TTL index (INDEXES.md) — a counter needs a timestamp to expire on.
    createdAt: isoDateSchema,
});
export function toDayKey(date) {
    return date.toISOString().slice(0, 10);
}
export function toMonthKey(date) {
    return date.toISOString().slice(0, 7);
}
export const statsOverviewSchema = z.object({
    today: z.object({ used: z.number().int(), limit: z.number().int() }),
    last30Days: z.object({ used: z.number().int(), limit: z.number().int() }),
    totalSent: z.number().int(),
    totalReceived: z.number().int(),
    deviceCount: z.number().int(),
    activeApiKeyCount: z.number().int(),
});
export const statsTimeseriesRangeEnum = z.enum(["7d", "30d", "90d"]);
export const statsTimeseriesQuerySchema = z.object({ range: statsTimeseriesRangeEnum });
export const statsTimeseriesPointSchema = z.object({
    date: z.string(),
    sent: z.number().int(),
    received: z.number().int(),
    delivered: z.number().int(),
    failed: z.number().int(),
});
//# sourceMappingURL=usage.js.map